var _defs, _rect, _circle, _line, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.79,
    y: 15.33,
    width: 51.41,
    height: 51.17,
    rx: 5,
    ry: 5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 50.48,
    cy: 53.81,
    r: 5.61
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.79,
    y1: 24.14,
    x2: 63.21,
    y2: 24.14
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m20.03,15.23v-4.49c0-1.24,1-2.24,2.24-2.24h4.49c1.24,0,2.24,1,2.24,2.24v4.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m45.99,15.23v-4.49c0-1.24,1-2.24,2.24-2.24h4.49c1.24,0,2.24,1,2.24,2.24v4.49"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/__Events.2acf6bcdd08a72d5f9c549d2d6a5c6d0.svg";
export { ForwardRef as ReactComponent };